'use strict';

class RcmFatContactEvents {
    constructor(fat) {
        this.fat = fat;

        this.onContactRequiredFieldsChange();
        this.onContactEmailFieldChange();
        this.onContactMessageFieldChange();
        this.onContactTopQuestionsFieldChange();
        this.onTOUFieldChange();
        this.onContactSubmitClick();
        this.setMapHeight();
    }

    // Map height resizer
    setMapHeight() {
        var self = this;
        this.fat.window.on('resize', self._helperDebounce(function(e) {
            var header = $('.fatv2-profile-header');
            if (header.length > 0 && self.fat.profile.mapElement && Foundation.MediaQuery.is('large')) {
                $(self.fat.profile.mapElement).css('height', header.outerHeight() + 'px');
            }
        }));
    }
    
    // On contact required fields change
    onContactRequiredFieldsChange() {
        this.fat.document.on('change_custom', this.fat.profileForm.requiredFieldsSelector, function (e) {
            var field = $(this);

            field.parent().removeClass('Error');
            field.siblings('.EditingFormErrorLabel').remove();

            if ($.trim(field.val()).length === 0) {
                field.parent().addClass('Error');
                field.after('<span class="EditingFormErrorLabel">This field is required</span>');
            }
        });
    }

    onContactMessageFieldChange() {
        this.fat.document.on('change_custom', this.fat.profileForm.messageSelector, function (e) {
            var field = $(this);

            field.parent().removeClass('Error');
            field.siblings('.EditingFormErrorLabel').remove();

            if (field.val().length > 4000) {
                field.parent().addClass('Error');
                field.after('<span class="EditingFormErrorLabel">The message length should not exceed 4000 characters</span>');
            }
        });
    }

    // On contact email field change
    onContactEmailFieldChange() {
        this.fat.document.on('change_custom', this.fat.profileForm.emailSelector, function (e) {
            var field = $(this);
            var fieldValue = field.val();
            var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            field.parent().removeClass('Error');
            field.siblings('.EditingFormErrorLabel').remove();

            // check that the emails match
            if (e.currentTarget.id == 'fatv2-email-confirm') {
                var primaryEmailField = document.getElementById('fatv2-email');
                var primaryEmailValue = primaryEmailField.value;
                if (primaryEmailValue !== fieldValue) {
                    field.parent().addClass('Error');
                    field.after('<span class="EditingFormErrorLabel">Email doesn\'t match</span>');
                }
            }
            else if ($.trim(fieldValue).length === 0 || !re.test($.trim(fieldValue))) {
                field.parent().addClass('Error');
                field.after('<span class="EditingFormErrorLabel">The email should be valid</span>');
            }
        });
    }

    // On top questions field change
    onContactTopQuestionsFieldChange() {
        this.fat.document.on('change_custom', this.fat.profileForm.topQuestionsSelector, function (e) {
            var field = $(this);
            
            field.parent().removeClass('Error');

            if (!field.is(':checked')) {
                field.parent().addClass('Error');
                alert('Please, you need to agree to receive teacher correspondence and other RCM communications, including "Top 10 Interview Questions to Ask Music Teachers". You can unsubscribe at any time.');
            }
        });
    }

    // On TOU field change
    onTOUFieldChange() {
        this.fat.document.on('change_custom', this.fat.profileForm.touSelector, function (e) {
            var field = $(this);

            field.parent().removeClass('Error');

            if (!field.is(':checked')) {
                field.parent().addClass('Error');
                alert('You need to agree with the Terms of Use.');
            }
        });
    }

    // On contact submit button click
    onContactSubmitClick() {
        var self = this;

        self.fat.document.on('click', self.fat.profileForm.submitSelector, function (e) {
            e.preventDefault();

            // Form not valid
            if (false == self.fat.profileForm.isFormValid()) {
                self.fat.profileForm.scrollToFieldWithError();
                return false;
            }

            // Fields
            var form = $(self.fat.profileForm.selector),
                fields = {
                    // Email
                    'email': form.find(self.fat.profileForm.emailSelector).val(),
                    // Phone
                    'phone': form.find(self.fat.profileForm.phoneSelector).val(),
                    'postal_code': form.find(self.fat.profileForm.postalCodeSelector).val(),
                    // Checkbox required to send the form
                    'topQuestions': form.find(self.fat.profileForm.topQuestionsSelector).is(':checked') ? true : false,
                    'touAgreement': form.find(self.fat.profileForm.touSelector).is(':checked') ? true : false,
                    // Recaptcha (JS)
                    'recaptcha': form.find(self.fat.profileForm.captchaSelector).val(),
                    'originURL': window.location.href
                };

            // Required fields
            $(self.fat.profileForm.requiredFieldsSelector).each(function () {
                var field = $(this);
                var name = field.attr('name');
                var value = field.val();

                if (name == 'teachernumber') {
                    // teachernumber
                    fields['teacherNumber'] = value;
                } else if (name == 'teacherfullname') {
                    fields['teacherFullName'] = value;
                } else if (name == 'first_name') {
                    // first_name
                    fields['firstName'] = value;
                } else if (name == 'last_name') {
                    // last_name
                    fields['lastName'] = value;
                } else {
                    // message
                    fields[name] = value;
                }
            });

            // Fields to submit
            fields = JSON.stringify(fields);

            // Show page loader
            self.fat.loader.show();

            // Hide feedback message
            self.fat.profileForm.hideFeedback();

            // Send message
            $.ajax({
                type: 'POST',
                url: '/RCM/API/NTDForm.asmx/SubmitForm',
                data: fields,
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',

                success: function (responseData, textStatus, jqXHR) {
                    responseData = JSON.parse(responseData.d);

                    // Success
                    if (responseData.Status == 'SUCCESS') {
                        // Update Google Analytics event
                        self.fat.google.trackGoogleAnalyticsEvent('Forms', 'Submit', 'Contact Teacher (Find a Teacher V2)');

                        // Show feedback message
                        self.fat.profileForm.showFeedback('Message sent!', 'success');

                        // Hide profile modal
                        /*if (self.fat.profile.profile.length > 0) {
                            self.fat.profile.hide();
                        }*/
                        // Error
                    } else if (responseData.Status == 'ERROR' && responseData.ErrorCode && responseData.ErrorCode != '') {
                        // Show feedback message
                        self.fat.profileForm.showFeedback(`Error trying to send the message: ${responseData.ErrorCode}`, 'alert');
                        // Error
                    } else {
                        self.fat.profileForm.showFeedback('Error trying to send the message.', 'alert');
                    }

                    // Hide page loader
                    self.fat.loader.hide();
                },

                error: function (responseData, textStatus, errorThrown) {
                    self.fat.loader.hide();
                    self.fat.profileForm.showFeedback('Error trying to send the message.', 'alert');
                }
            });

            return true;
        });
    }

    _helperDebounce(func) {
        var timer;

        return function (event) {
            if (timer) clearTimeout(timer);
            timer = setTimeout(func, 100, event);
        };
    }
}
